import { GlobalContextUserRole } from "@shared/context/GlobalConfig";

type GetRoleProps = {
  userId?: string;
  roleId?: string;
  roleType?: string;
};

const getRole = ({ userId, roleId, roleType }: GetRoleProps): GlobalContextUserRole => {
  if (userId && !roleId) {
    return GlobalContextUserRole.ROLELESS;
  }

  switch (roleType) {
    case "Practitioner":
      return GlobalContextUserRole.PRACTITIONER;
    case "OrganizationManager":
      return GlobalContextUserRole.ORG_MANAGER;
    case "Clerk":
      return GlobalContextUserRole.CLERK;
    case "Patient":
      return GlobalContextUserRole.PATIENT;
  }

  return GlobalContextUserRole.UNAUTHENTICATED;
};

export { getRole };
